import { Lens } from '@dhmk/zustand-lens';

import type { ChatIdentityKey } from '@/api/chat/query-keys';

export interface ShellRun {
  identity: ChatIdentityKey;
  locationKey: string;
}

export interface CommunicationsShellSlice {
  lastIdentity: ChatIdentityKey | null;
  entryIdentities: Record<string, ChatIdentityKey>;
  rememberShellRun: (_run: ShellRun) => void;
  resetState: () => void;
}

// A tab's reachable session history is far shorter, so older entries can never be returned to.
const MAX_REMEMBERED_ENTRIES = 100;

const initialState: Pick<CommunicationsShellSlice, 'lastIdentity' | 'entryIdentities'> = {
  lastIdentity: null,
  entryIdentities: {},
};

export const createCommunicationsShellStore: Lens<CommunicationsShellSlice> = (set) => ({
  ...initialState,
  rememberShellRun: ({ identity, locationKey }) =>
    set((state) => {
      state.lastIdentity = identity;
      delete state.entryIdentities[locationKey];
      state.entryIdentities[locationKey] = identity;

      const keys = Object.keys(state.entryIdentities);
      keys
        .slice(0, Math.max(0, keys.length - MAX_REMEMBERED_ENTRIES))
        .forEach((key) => delete state.entryIdentities[key]);
    }),
  resetState: () => set(() => initialState),
});
